import { handleRequest } from '../redux/services/APIService';
import localStorage from '../libs/storageHelper';

/**
 * Facility home for established Admin / Primary Admin / Staff after login
 * or session restore. Mixed or vet-only → Refill Requests;
 * boarding-only → Photo Update Board.
 */
export async function getAppHomePath() {
  const loggedUser = localStorage.getFromStorage('loggedUser');
  const facilityId = loggedUser?.user?.facility;

  if (!facilityId) {
    return '/refill-requests';
  }

  try {
    const response = await handleRequest(
      'get',
      `facility/${facilityId}`,
      true,
    );
    const services = response.data?.services || { veterinaryOffered: true };
    const isBoardingOnly =
      services.boardingOffered === true &&
      services.veterinaryOffered === false;

    return isBoardingOnly ? '/tracking-board' : '/refill-requests';
  } catch {
    return '/refill-requests';
  }
}
